export enum BULLMQ_JOBS {
  STUDENT_BULK_UPLOAD = 'STUDENT_BULK_UPLOAD',
  CURRICULUM_BULK_UPLOAD = 'CURRICULUM_BULK_UPLOAD',
  ACADEMIC_YEAR_BULK_UPLOAD = 'ACADEMIC_YEAR_BULK_UPLOAD',
  CURRICULUM_PREFERENCE_BULK_UPLOAD = 'CURRICULUM_PREFERENCE_BULK_UPLOAD',
  SUBJECT_BULK_UPLOAD = 'SUBJECT_BULK_UPLOAD',
  GRADE_BULK_UPLOAD = 'GRADE_BULK_UPLOAD',
  CLASSROOM_BULK_UPLOAD = 'CLASSROOM_BULK_UPLOAD',
  SYLLABUS_BULK_UPLOAD = 'SYLLABUS_BULK_UPLOAD',
  TEACHER_BULK_UPLOAD = 'TEACHER_BULK_UPLOAD',
  GUARDIAN_BULK_UPLOAD = 'GUARDIAN_BULK_UPLOAD',
}

export enum MESSAGE_QUEUE_STATUS {
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN PROGRESS',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}
